<script>
import Layout from "@/router/layouts/main";
import Stat from "@/components/widgets/stat";
import { api } from "@/state/services";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    Layout,
    Stat,
  },
  data() {
    return {
      filter: {
        list: "all",
        status: "all",
      },

      search: "",

      lists: null,

      statData: [
        { type: "line", icon: "bx-user-plus", title: "Disponível", value: "-" },
        { type: "line", icon: "bx-user-x", title: "Pendentes", value: "-" },
        { type: "line", icon: "bx-user-check", title: "Aprovados", value: "-" },
      ],

      fields: [
        { key: "name", label: "Nome / Razão Social" },
        { key: "personNumber", label: "CPF / CNPJ" },
        { key: "status", label: "Status" },
        { key: "documents", label: "Documentos" },
        { key: "observations", label: "" },
        { key: "list", label: "Lista" },
        { key: "actions", label: "", tdClass: 'text-right' },
      ],

      total: 0,
      currentPage: "1",
      perPage: "25",

      balance: {
        available: 0,
        blocked: 0,
      },

      clients: null,

      add: {
        modal: false,
        loading: false,
        type: "natural",
        name: "",
        personNumber: "",
        companyPartnerName: "",
        companyPartnerCpf: "",
        email: "",
        cellphone: "",
        observations: "",
      },

      view: {
        modal: false,
        client: {
          id: null,
          status: "",
          date_added: "",
          date_approved: "",
          type: "",
          name: "",
          personNumber: "",
          companyPartnerName: "",
          companyPartnerCpf: "",
          email: "",
          cellphone: "",
          observations: "",
          documents: {
            types: [],
            list: [],
          },
        }
      },

      payment: {
        modal: false,
        client: null,
      },

      pendings: {
        modal: false,
        loading: false,
        clients: null,
        ids: [],
      },

      del: {
        modal: false,
        loading: false,
        client: null,
      },

      document: {
        modal: false,
        loading: false,
        id: null,
        type: {
          id: null,
          name: null,
        },
        choosed: null,
        file: null,
      },
    };
  },
  validations: {
    add: {
      type: { required },
      name: { required },
      personNumber: { required },
      companyPartnerName: { },
      companyPartnerCpf: { },
      email: { required },
      cellphone: { required },
      observations: { },
    },
  },
  methods: {
    getClients() {
      this.clients = null;

      api
        .get("bacen/clients?list=" + this.filter.list + "&status=" + this.filter.status)
        .then((response) => {
          if (response.data.status == "success") {
            this.lists = response.data.lists;
            this.total = response.data.list.length;

            this.balance.available = response.data.balance.available;
            this.balance.blocked = response.data.balance.blocked;

            this.statData = [
              { type: "line", icon: "bx-user-plus", title: "Disponível", value: response.data.balance.available.toString() },
              { type: "line", icon: "bx-user-x", title: "Pendentes", value: response.data.total.pending.toString() },
              { type: "line", icon: "bx-user-check", title: "Aprovados", value: response.data.total.approved.toString() },
            ];

            this.clients = response.data.list;
          }
        })
        .catch((error) => {
          if (error) {
            this.clients = [];
          }
        })
    },
    showAdd() {
      this.add.modal = false;
      this.add.modal = true;
      this.add.loading = false;
    },
    addClient() {
      this.add.loading = true
      this.$v.add.$touch();

      if (!this.$v.add.$invalid) {
        api
          .post('bacen/clients', {
            type: this.add.type,
            name: this.add.name,
            personNumber: this.add.personNumber,
            companyPartnerName: this.add.companyPartnerName,
            companyPartnerCpf: this.add.companyPartnerCpf,
            email: this.add.email,
            cellphone: this.add.cellphone,
            observations: this.add.observations,
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.add.type = ''
              this.add.name = ''
              this.add.personNumber = ''
              this.add.companyPartnerName = ''
              this.add.companyPartnerCpf = ''
              this.add.email = ''
              this.add.cellphone = ''
              this.add.observations = ''
              this.$v.add.$reset()

              this.add.modal = false
              this.add.loading = false

              this.$toast.success('O cliente adicionado com sucesso!')

              this.getClients()
            } else {
              this.add.loading = false
              this.$toast.error(response.data.message)
            }
          })
          .catch(error => {
            if (error) {
              this.add.loading = false
            }
          })
      } else {
        this.add.loading = false
      }
    },
    showView(client) {
      this.view.modal = false;
      this.view.modal = true;
      this.view.client.id = client.id;
      this.view.client.status = client.status;
      this.view.client.date_added = client.date_added;
      this.view.client.date_approved = client.date_approved;
      this.view.client.type = client.type;
      this.view.client.name = client.name;
      this.view.client.personNumber = client.personNumber;
      this.view.client.companyPartnerName = client.companyPartnerName;
      this.view.client.companyPartnerCpf = client.companyPartnerCpf;
      this.view.client.email = client.email;
      this.view.client.cellphone = client.cellphone;
      this.view.client.observations = client.observations;
      this.view.client.documents.types = [];
      this.view.client.documents.list = [];

      api
        .get('bacen/clients/' + client.id + '/documents')
        .then((response) => {
          if (response.data.status == "success") {
            this.view.client.documents.types = response.data.types;
            this.view.client.documents.list = response.data.list;
          }
        })
    },
    showPayment(client) {
      this.payment.modal = false;
      this.payment.modal = true;
      this.payment.client = client;
    },
    payClient(id) {
      this.payment.loading = true;

      api
        .post('bacen/clients/payment', {
          id: id
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success("O pagamento foi realizado com sucesso!");

            this.payment.modal = false;
            this.payment.loading = false;
            this.view.modal = false;

            this.getClients();
          } else {
            this.$toast.error(response.data.message);
            this.payment.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("Erro ao realizar pagamento, tente novamente.");
            this.payment.loading = false;
          }
        });
    },
    showDel(client) {
      this.del.modal = false;
      this.del.modal = true;
      this.del.client = client;
    },
    showPendings() {
      this.pendings.modal = false;
      this.pendings.modal = true;
      this.pendings.loading = false;
      this.pendings.clients = null;
      this.pendings.ids = [];

      api
        .get('bacen/clients/pendings')
        .then((response) => {
          if (response.data.status == "success") {
            this.pendings.clients = response.data.list;
          }
        })
    },
    deselectAll() {
      this.pendings.ids = [];
    },
    selectAll() {
      this.pendings.ids = this.pendings.clients.map(client => client.id);
    },
    payPendings() {
      this.pendings.loading = true;

      api
        .post('bacen/clients/pendings', {
          ids: this.pendings.ids
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.getClients();

            this.pendings.modal = false;
            this.pendings.loading = false;
            this.pendings.clients = null;
            this.pendings.ids = [];
            this.$toast.success("O pagamento foi realizado com sucesso!");
          } else {
            this.pendings.loading = false;
            this.$toast.error(response.data.message);
          }
        })
        .catch((error) => {
          if (error) {
            this.pendings.loading = false;
            this.$toast.error("Erro ao realizar pagamento, tente novamente.");
          }
        });
    },
    delClient(id) {
      this.del.loading = true;

      api
        .post('bacen/clients/delete', {
          id: id
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success("O cliente foi excluído com sucesso!");

            this.del.modal = false;
            this.del.loading = false;
            this.view.modal = false;

            this.getClients();
          } else {
            this.$toast.error(response.data.message);
            this.del.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("Erro ao excluir cliente, tente novamente.");
            this.del.loading = false;
          }
        });
    },
    exportClients() {
      api
      .get('bacen/clients/export?list=' + this.filter.list + '&status=' + this.filter.status)
      .then((response) => {
        if (response.data.status == "success") {
          const fileBase64 = response.data.base64;
          const mimeType = response.data.mimetype || 'application/octet-stream';
          const filename = response.data.filename || 'relatorio.xlsx';

          const byteCharacters = atob(fileBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          const blob = new Blob([byteArray], { type: mimeType });

          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);

          this.$toast.success("A lista de clientes foi exportada com sucesso!");
        } else {
          this.$toast.error(response.data.message);
        }
      });
    },
    showDocument(id, typeId, typeName) {
      this.document.modal = false;
      this.document.modal = true;
      this.document.id = id;
      this.document.type.id = typeId;
      this.document.type.name = typeName;
      this.document.file = null;
      this.document.choosed = null;
    },
    sendDocument() {
      if (!this.document.file) {
        this.$toast.error("Selecione um arquivo para enviar.");
        return;
      }

      this.document.loading = true;

      let formData = new FormData();
      formData.append("file", this.document.file);

      api
        .post(
          "bacen/clients/" + this.document.id + "/documents/" + this.document.type.id,
          formData
        )
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(response.data.message);
            this.getClients();
            this.showView(this.view.client);

            this.document.modal = false;
            this.document.choosed = null;
            this.document.file = null;
            this.document.loading = false;
            this.document.type.id = null;
            this.document.type.name = null;
          } else {
            this.$toast.error(response.data.message);
            this.document.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("Erro ao enviar documento, tente novamente.");
            this.document.loading = false;
          }
        });
    },
    onFileSelected() {
      const fileInput = this.$refs.file;
      if (fileInput && fileInput.files && fileInput.files[0]) {
        this.document.file = fileInput.files[0];
        this.document.choosed = fileInput.files[0].name;
      } else {
        this.document.file = null;
        this.document.choosed = null;
      }
    },
  },
  mounted() {
    this.getClients();
  },
  watch: {
    "filter.list": function () {
      this.getClients();
    },
    "filter.status": function () {
      this.getClients();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Bacen</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Clientes</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-6 col-md-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4">
      <b-dropdown variant="outline-light">
        <template #button-content>
          ações
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <b-dropdown-item v-on:click="showAdd();">Novo</b-dropdown-item>
        <b-dropdown-item v-on:click="showImport();" disabled>Importar</b-dropdown-item>
        <b-dropdown-item v-on:click="showPendings();">Pagar</b-dropdown-item>
        <b-dropdown-item v-on:click="exportClients();">Exportar</b-dropdown-item>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Listas</h6>
              <div v-if="filter.list == 'all'">Todos</div>
              <div v-else-if="lists.find(list => list.id === filter.list)">{{lists.find(list => list.id === filter.list).name }}</div>
              <div v-else>–</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filter.list" value="all">Todos</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="list of lists" :key="list.id">
          <b-form-radio v-model="filter.list" :value="list.id">{{ list.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Status</h6>
              <div v-if="filter.status == 'all'">Todos</div>
              <div v-else-if="filter.status == 'pending'">Pendente</div>
              <div v-else-if="filter.status == 'approved'">Pago</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="all">Todos</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="pending">Pendente</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="approved">Pago</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <div class="totals">
        <h6 class="m-0 text-secondary text-lowercase">Total</h6>
        <div>{{ this.total }}</div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!clients">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="clients && clients.length == 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">

          <b-input v-model="search" placeholder="Busca" class="mb-4"></b-input>

          <b-table :items="clients" :fields="fields" class="table-nowrap table-style table-hover table-pointer min-vh-25" head-variant="light" @row-clicked="showView" :current-page="currentPage"
            :per-page="perPage" :filter="search" responsive>
            <template #cell(status)="row">
              <span class="badge badge-soft-danger font-size-13" v-if="row.item.status == 'pending'">PENDENTE</span>
              <span class="badge badge-soft-success font-size-13" v-else-if="row.item.status == 'approved'">PAGO</span>
              <span class="badge badge-soft-warning font-size-13" v-else-if="row.item.status == 'deleted'">EXCLUÍDO</span>
              <span class="badge badge-soft-warning font-size-13" v-else-if="row.item.status == 'canceled'">CANCELADO</span>
            </template>
            <template #cell(documents)="row">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :style="{ fill: row.item.documents.scr.status == 'approved' ? '#41B883' : (row.item.documents.scr.status == 'pending' ? '#50A5F1' : '#aaa') }">
                <path
                  d="M6 22h12c.178 0 .348-.03.512-.074l-3.759-3.759A4.966 4.966 0 0 1 12 19c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5a4.964 4.964 0 0 1-.833 2.753l3.759 3.759c.044-.164.074-.334.074-.512V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2z">
                </path>
                <circle cx="12" cy="14" r="3"></circle>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :style="{ fill: row.item.documents.procuracao.status == 'approved' ? '#41B883' : (row.item.documents.procuracao.status == 'pending' ? '#50A5F1' : '#aaa') }">
                <path d="m18.988 2.012 3 3L19.701 7.3l-3-3zM8 16h3l7.287-7.287-3-3L8 13z"></path>
                <path d="M19 19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .896-2 2v14c0 1.104.897 2 2 2h14a2 2 0 0 0 2-2v-8.668l-2 2V19z"></path>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :style="{ fill: row.item.documents.identidade.status == 'approved' ? '#41B883' : (row.item.documents.identidade.status == 'pending' ? '#50A5F1' : '#aaa') }">
                <path
                  d="M6 22h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h1zm6-17.001c1.647 0 3 1.351 3 3C15 9.647 13.647 11 12 11S9 9.647 9 7.999c0-1.649 1.353-3 3-3zM6 17.25c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18H6v-.75z">
                </path>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :style="{ fill: row.item.documents.residencia.status == 'approved' ? '#41B883' : (row.item.documents.residencia.status == 'pending' ? '#50A5F1' : '#aaa') }">
                <path
                  d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z">
                </path>
              </svg>
            </template>
            <template #cell(observations)="row">
              <div v-if="row.item.observations">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, .8);">
                  <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                  <path d="M11 11h2v6h-2zm0-4h2v2h-2z"></path>
                </svg>
              </div>
            </template>
            <template #cell(list)="row">
              <div v-if="row.item.list && row.item.status == 'approved'" class="d-flex align-items-center flex-gap-5">
                <small class="py-2 align-top">{{ row.item.list.name }}</small>
              </div>
            </template>
            <template #cell(actions)="row">
              <div v-if="row">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                  <path d="M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"></path>
                  <path
                    d="M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z">
                  </path>
                </svg>
              </div>
            </template>
          </b-table>

          <b-pagination v-if="search == ''" class="mt-4" v-model="currentPage" :total-rows="total" :per-page="perPage" pills align="center"></b-pagination>
        </div>
      </div>
    </div>

    <b-modal v-model="add.modal" title="Novo Cliente" modal-class="modal-right" hide-footer>
      <b-form @submit.prevent="addClient">
        <b-form-group id="type-group" :label="t('Tipo de Pessoa')" label-for="type">
          <select v-model="add.type" class="custom-select mb-1">
            <option value="">–</option>
            <option value="natural">Pessoa Física</option>
            <option value="legal">Pessoa Jurídica</option>
          </select>
        </b-form-group>
        <template v-if="add.type == 'natural'">
          <b-form-group id="name-group" label="Nome" label-for="name">
            <b-form-input id="name" v-model="add.name" type="text" :class="{ 'is-invalid': $v.add.name.$error }"></b-form-input>
            <div v-if="!$v.add.name.required" class="invalid-feedback">
              O nome é obrigatório.
            </div>
          </b-form-group>

          <b-form-group id="cpf-group" label="CPF" label-for="cpf">
            <b-form-input id="cpf" v-model="add.personNumber" type="text" v-mask="'###.###.###-##'" :class="{ 'is-invalid': $v.add.personNumber.$error }" inputmode="numeric"></b-form-input>
            <div v-if="!$v.add.personNumber.required" class="invalid-feedback">
              O CPF é obrigatório.
            </div>
          </b-form-group>
        </template>
        <template v-else>
          <b-form-group id="name-group" label="Razão Social" label-for="name">
            <b-form-input id="name" v-model="add.name" type="text" :class="{ 'is-invalid': $v.add.name.$error }"></b-form-input>
            <div v-if="!$v.add.name.required" class="invalid-feedback">
              O nome é obrigatório.
            </div>
          </b-form-group>

          <b-form-group id="cnpj-group" label="CNPJ" label-for="cnpj">
            <b-form-input id="cnpj" v-model="add.personNumber" type="text" v-mask="'##.###.###/####-##'" :class="{ 'is-invalid': $v.add.personNumber.$error }" inputmode="numeric"></b-form-input>
            <div v-if="!$v.add.personNumber.required" class="invalid-feedback">
              O CNPJ é obrigatório.
            </div>
          </b-form-group>

          <b-form-group id="partner-name-group" label="Nome do Sócio" label-for="partner-name">
            <b-form-input id="partner-name" v-model="add.companyPartnerName" type="text" :class="{ 'is-invalid': $v.add.companyPartnerName.$error }"></b-form-input>
            <div v-if="!$v.add.companyPartnerName.required" class="invalid-feedback">
              O nome do sócio é obrigatório.
            </div>
          </b-form-group>

          <b-form-group id="partner-cpf-group" label="CPF do Sócio" label-for="cpf">
            <b-form-input id="cpf" v-model="add.companyPartnerCpf" type="text" v-mask="'###.###.###-##'" :class="{ 'is-invalid': $v.add.companyPartnerCpf.$error }" inputmode="numeric"></b-form-input>
            <div v-if="!$v.add.companyPartnerCpf.required" class="invalid-feedback">
              O CPF do sócio é obrigatório.
            </div>
          </b-form-group>

        </template>

        <b-form-group id="email-group" label="Email" label-for="email">
          <b-form-input id="email" v-model="add.email" type="email" :class="{ 'is-invalid': $v.add.email.$error }" inputmode="email"></b-form-input>
          <div v-if="!$v.add.email.required" class="invalid-feedback">
            O email é obrigatório.
          </div>
        </b-form-group>

        <b-form-group id="cellphone-group" label="Celular/Whatsapp" label-for="cellphone">
          <b-form-input id="cellphone" v-model="add.cellphone" type="text" v-mask="'(##) #####-####'" :class="{ 'is-invalid': $v.add.cellphone.$error }" inputmode="numeric"></b-form-input>
          <div v-if="!$v.add.cellphone.required" class="invalid-feedback">
            O celular é obrigatório.
          </div>
        </b-form-group>

        <b-form-group id="observations-group" label="Observações" label-for="observations">
          <b-form-textarea id="observations" v-model="add.observations" maxlength="100" :class="{ 'is-invalid': $v.add.observations.$error }"></b-form-textarea>
          <div class="font-size-12 p-2 px-3 mt-1 bg-soft-info rounded d-flex flex-gap-10 align-items-center" style="line-height: 15px;">
            <span>{{ add.observations.length }}/100 caracteres</span>
          </div>
        </b-form-group>

        <b-button class="mt-5 btn-lg btn-block" :disabled="this.add.loading" type="submit" variant="default">
          Adicionar
          <b-spinner v-if="add.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
      </b-form>
    </b-modal>

    <b-modal v-model="view.modal" title="Dados do Cliente" modal-class="modal-right" hide-footer>
      <div>
        <div class="mb-3"><strong class="font-size-12">Criado em {{ view.client.date_added }}</strong></div>
      </div>
      <template v-if="view.client.type == 'natural'">
        <div class="mb-3"><strong class="font-size-12">Nome</strong><br><span class="font-size-16">{{ view.client.name }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CPF</strong><br><span class="font-size-16">{{ view.client.personNumber }}</span></div>
      </template>
      <template v-else>
        <div class="mb-3"><strong class="font-size-12">Razão Social</strong><br><span class="font-size-16">{{ view.client.name }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CNPJ</strong><br><span class="font-size-16">{{ view.client.personNumber }}</span></div>
        <div class="mb-3"><strong class="font-size-12">Nome do Sócio</strong><br><span class="font-size-16">{{ view.client.companyPartnerName }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CPF do Sócio</strong><br><span class="font-size-16">{{ view.client.companyPartnerCpf }}</span></div>
      </template>
      <div class="mb-3"><strong class="font-size-12">Email</strong><br><span class="font-size-16">{{ view.client.email }}</span></div>
      <div class="mb-3"><strong class="font-size-12">Celular</strong><br><span class="font-size-16">{{ view.client.cellphone }}</span></div>
      <div class="mb-3">
        <strong class="font-size-12">Status</strong><br>
        <span class="badge badge-soft-danger p-2 font-size-14" v-if="view.client.status == 'pending'">PENDENTE</span>
        <template v-else-if="view.client.status == 'approved'">
          <span class="badge badge-soft-success p-2 mb-1 mr-1 font-size-14">PAGO</span>
          <span class="font-size-14 text-center">{{ view.client.date_approved }}</span>
        </template>
      </div>
      <div class="mb-3" v-if="view.client.observations">
        <strong class="font-size-12">Observações</strong><br>
        <fieldset v-html="view.client.observations">
        </fieldset>
      </div>
      <div class="mb-3">
        <div v-for="(type, index) in view.client.documents.types" :key="index" class="mb-3">
          <fieldset class="mb-0">
            <legend class="font-size-12">{{ type }}</legend>
            <div v-if="view.client.documents.list[index].status == 'waiting'">
              <span class="badge badge-warning py-3 font-size-16 font-weight-bold w-100 mb-2">aguardando envio</span>
              <button class="btn btn-default btn-lg btn-block" v-on:click="showDocument(view.client.id, index, type)">Enviar Documento</button>
            </div>
            <div v-else-if="view.client.documents.list[index].status == 'pending'">
              <span class="badge badge-info py-3 font-size-16 font-weight-bold w-100 mb-2">aguardando validação</span>
              <a class="btn btn-primary btn-lg btn-block" :href="view.client.documents.list[index].url" target="_blank">Visualizar Documento</a>
            </div>
            <div v-else-if="view.client.documents.list[index].status == 'approved'">
              <span class="badge badge-success py-3 font-size-16 font-weight-bold w-100 mb-2">aprovado</span>
              <a class="btn btn-info btn-lg btn-block" :href="view.client.documents.list[index].url" target="_blank">Visualizar Documento</a>
            </div>
            <div v-else-if="view.client.documents.list[index].status == 'repproved'">
              <span class="badge badge-danger py-3 font-size-16 font-weight-bold w-100 mb-2">reprovado</span>
              <a class="btn btn-info btn-lg btn-block" :href="view.client.documents.list[index].url" target="_blank">Visualizar Documento</a>
              <button class="btn btn-default btn-lg btn-block" v-on:click="showDocument(view.client.id, index, type)">Reenviar Documento</button>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="mt-5">
        <button v-if="view.client.status == 'pending'" class="btn btn-success btn-lg btn-block" v-on:click="showPayment(view.client)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path
              d="M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z">
            </path>
            <path d="M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"></path>
          </svg>
          Realizar Pagamento
        </button>
        <button v-else class="btn btn-success btn-lg btn-block" disabled>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path
              d="M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z">
            </path>
            <path d="M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"></path>
          </svg>
          Realizar Pagamento
        </button>
      </div>
      <div class="mt-3">
        <button v-if="view.client.status == 'pending'" class="btn btn-danger btn-lg btn-block" v-on:click="showDel(view.client)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
            <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
          </svg>
          Excluir Cliente
        </button>
        <button v-else class="btn btn-danger btn-lg btn-block" disabled>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
            <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
          </svg>
          Excluir Cliente
        </button>
      </div>
    </b-modal>

    <b-modal v-model="payment.modal" modal-class="modal-bottom" hide-footer hide-header>
      <div class="px-3">
        <h5 class="mb-4" v-if="payment.client">Deseja realizar o pagamento do cliente <span class="bg-soft-dark px-2 rounded text-uppercase">{{ payment.client.name }}</span>?</h5>
        <div class="mt-4 d-flex justify-content-between">
          <b-button class="btn-lg" variant="default" :disabled="this.payment.loading" v-on:click="payClient(view.client.id)">
            Pagar
            <b-spinner v-if="payment.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
          <b-button class="text-dark text-decoration-none" variant="link" v-on:click="payment.modal = false">Fechar</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="pendings.modal" title="Pagar" modal-class="modal-right" hide-footer>
      <b-form @submit.prevent="payPendings">
        <div v-if="!pendings.clients" class="text-center">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>
        <div v-else-if="pendings.clients && pendings.clients.length == 0">
          <div class="text-center">
            <div class="mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-15h2v6h-2zm0 8h2v2h-2z"></path>
              </svg>
            </div>
            <div class="mb-3">Nenhum cliente pendente para pagamento.</div>
          </div>
        </div>
        <div v-else>
          <div class="d-flex flex-gap-10 mb-3">
            <div class="flex-fill">
              <div class="bg-light rounded p-3 text-center">
                <h5 class="mt-1 mb-0">{{ balance.available }}</h5>
                <div class="mb-0 font-size-12 text-uppercase">Disponível</div>
              </div>
            </div>
            <div class="flex-fill">
              <div class="bg-light rounded p-3 text-center">
                <h5 class="mt-1 mb-0">{{ pendings.clients.length }}</h5>
                <div class="mb-0 font-size-12 text-uppercase">Pendentes</div>
              </div>
            </div>
            <div class="flex-fill">
              <div class="bg-light rounded p-3 text-center">
                <h5 class="mt-1 mb-0">{{ pendings.ids.length }}</h5>
                <div class="mb-0 font-size-12 text-uppercase">Selecionados</div>
              </div>
            </div>
          </div>

          <div style="max-height: 40vh; overflow-y: auto;" class="border rounded p-3">
            <b-form-checkbox v-for="client of pendings.clients" :key="client.id" v-model="pendings.ids" :value="client.id" class="pendings-client bg-soft-light rounded mb-2" style="line-height: 15px;"
              v-bind:class="{ 'client-selected': pendings.ids.includes(client.id) }">
              <div>{{ client.name }}</div>
              <div class="text-muted">{{ client.personNumber }}</div>
            </b-form-checkbox>
          </div>
          <div class="mt-3 d-flex flex-gap-10">
            <div class="flex-fill w-50">
              <button type="button" class="btn btn-secondary btn-block" v-on:click="deselectAll()">Desselecionar</button>
            </div>
            <div class="flex-fill w-50">
              <button type="button" class="btn btn-secondary btn-block" v-on:click="selectAll()">Todos</button>
            </div>
          </div>
          <b-button class="mt-5 btn-lg btn-block" :disabled="balance == 0 || pendings.ids.length == 0 || pendings.ids.length > balance.available || this.pendings.loading" type="submit"
            variant="success">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
              <path
                d="M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z">
              </path>
              <path d="M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"></path>
            </svg>
            Realizar Pagamento
            <b-spinner v-if="pendings.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal v-model="del.modal" modal-class="modal-bottom" hide-footer hide-header>
      <div class="px-3">
        <h5>Você tem certeza que deseja excluir este cliente?</h5>
        <div class="mt-4 d-flex justify-content-between">
          <b-button class="btn-lg" variant="danger" :disabled="this.add.loading" v-on:click="delClient(view.client.id)">
            Excluir
            <b-spinner v-if="del.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
          <b-button class="text-dark text-decoration-none" variant="link" v-on:click="del.modal = false">Fechar</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="document.modal" title="Documentos" modal-class="modal-right" hide-footer>
      <b-form @submit.prevent="sendDocument">
        <h5 class="mb-4">{{ document.type.name }}</h5>
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div class="input-group">
            <div class="custom-file">
              <input type="file" id="file" ref="file" class="custom-file-input" @change="onFileSelected" aria-describedby="inputGroupFileAddon01" />
              <label class="custom-file-label" for="file" v-if="document.choosed == null">Escolher arquivo</label>
              <label class="custom-file-label" for="file" v-else>{{ document.choosed }}</label>
            </div>
          </div>
        </div>
        <b-button class="btn-lg btn-block" type="submit" variant="default" :disabled="document.loading">
          Enviar
          <b-spinner v-if="document.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
      </b-form>
    </b-modal>
  </Layout>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>

<style>
.pendings-client {
  padding: 0 !important;
  margin: 0 !important;
  margin-bottom: 10px !important;
}

.pendings-client * {
  cursor: pointer !important;
}

.pendings-client .custom-control-label:before {
  top: 20px;
  left: 16px;
  width: 20px;
  height: 20px;
}

.pendings-client .custom-control-label:after {
  top: 20px;
  left: 16px;
  width: 20px;
  height: 20px;
}

.pendings-client .custom-control-label {
  padding: 15px 15px 15px 50px;
  width: 100%;
}

.pendings-client.client-selected {
  background-color: #bdf4d5 !important;
}
.pendings-client.client-selected .custom-control-input:checked~.custom-control-label::before {
  border-color: #34C391 !important;
  background-color: #34C391 !important;
}
</style>

